import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { Provisao } from '../../../../types/Provisao.type';

@Injectable({
  providedIn: 'root'
})
export class ProvisaoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getProvisoes(instancias: string, dataInicial: string | null, dataFinal: string | null) {
    return this.httpClient.get<Provisao[]>(`${this.configService.getApiUrlRoot()}/provisoes/?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  sincronizaProvisoes(instancias: string, dataInicial: string | null, dataFinal: string | null) {
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/provisoes/pims/buscar?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  integrarProvisoes(corpo: any) {
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/provisoes/integracao/integra-erp`, corpo);
  }
  exportarProvisoes(corpo: any) {
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/provisoes/relatorios/exportar`, corpo, { responseType: 'blob' })
  }

  postCancelarProvisao(corpo: any) {
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/provisoes/cancelar`, corpo)
  }

  postEstornarProvisao(corpo: any) {
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/provisoes/estornar`, corpo)
  }

  postCancelarEstornarProvisao(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/provisao/cancelar-estornar`, corpo)
  }
}
